import { render, staticRenderFns } from "./ModalUnsuccessful.vue?vue&type=template&id=0c31f836&scoped=true"
import script from "./ModalUnsuccessful.vue?vue&type=script&lang=js"
export * from "./ModalUnsuccessful.vue?vue&type=script&lang=js"
import style0 from "./ModalUnsuccessful.vue?vue&type=style&index=0&id=0c31f836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c31f836",
  null
  
)

export default component.exports